import React, { Component } from 'react';
import { Container } from 'react-grid-system';
import styled from 'styled-components';
import Colors from '../../shared/colors';
import BackgroundGrey from '../../images/backgroundGrey.png';
import BackgroundPrato from '../../images/backgroundPratos.png';
import { Scrollbars } from 'react-custom-scrollbars';

export default class Preparation extends Component {
    render() {
        const {
            t,
            data
        } = this.props;

        return(
            <Master>
                <MasterBackgroundLeft>
                </MasterBackgroundLeft>
                <MasterBackgroundRight>
                </MasterBackgroundRight>
                <PreparationWrapper>
                    <Container className="bannerSize">
                        <PreparationContent>
                            <PreparationTitle>
                                <Title>
                                    {t('MODE DE PREPARAÇÃO DO PRATO')}
                                </Title>
                            </PreparationTitle>
                            <PreparationList>
                                <Scrollbars style={{ height: 470 }}>
                                    {
                                        data.preparation.map((prepar, index) => {
                                            return(
                                                <ListRow key={index}>
                                                    <Number>
                                                        {index + 1}
                                                    </Number>
                                                    <Text>
                                                        {prepar}
                                                    </Text>
                                                </ListRow>
                                            )
                                        })
                                    }
                                </Scrollbars>
                            </PreparationList>
                        </PreparationContent>
                    </Container>
                </PreparationWrapper>
            </Master>
        )
    }
}

const Master = styled.div `
    width: 100%;
    height: 660px;
    display: flex;
    position: relative;

    @media screen and (max-width: 1320px) {
        height: 720px;
    }

    @media screen and (max-width: 767px) {
        height: 750px;
    }

    @media screen and (max-width: 407px) {
        height: 800px;
    }
`
const MasterBackgroundLeft = styled.div `
    width: 30%;
    height: 100%;
    background-size: cover;
    background-position: fixed;
    background-repeat: no-repeat;
    background-image: url(${BackgroundPrato});
    position: relative;

    &:after{
        height: 170px;
        display: block;
        width: 8px;
        background: ${Colors.primary};
        content: '';
        position: absolute;
        right: -4px;
        top: 245px;
    } 

    @media screen and (max-width: 1320px) {
        display: none;
    } 
`
const MasterBackgroundRight = styled.div `
    width: 70%;
    height: 100%;
    background-size: cover;
    background-position: fixed;
    background-repeat: no-repeat;
    background-image: url(${BackgroundGrey});

    @media screen and (max-width: 1320px) {
        width: 100%;
    } 
`
const PreparationWrapper = styled.div `
    width: 100%;
    height: 660px;
    position: absolute; 
    top: 0;
`
const PreparationContent = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    
    @media screen and (max-width: 1320px) {
        display: block;
        padding-top: 80px;
        padding-bottom: 0px;
    } 
`
const PreparationTitle = styled.div `
    width: 50%;
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 1320px) {
        width: 100%;
        margin-bottom: 30px;
    } 
`
const Title = styled.div `
    width: 230px;
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
    font-size: 36px;
    font-weight: bold;
    line-height: 48px;

    @media screen and (max-width: 1320px) {
        width: 100%;
    } 
    @media screen and (max-width: 567px) {
        text-align: center;
    } 
`
const PreparationList = styled.div `
    width: 40%;
    max-height: 470px;
    overflow-y: auto;

    @media screen and (max-width: 1320px) {
        width: 100%; 
    } 
`
const ListRow = styled.div `
    display: flex;
    align-items: center;
    border: 1px solid ${Colors.primary};
    min-height: 72px;
    padding: 2px 0;
    margin-bottom: 10px;
`
const Number = styled.div `
    width: 70px;
    height: 100%;
    color: ${Colors.primary};
    font-family: "PT Sans";
    font-size: 24px;
    font-weight: bold;
    border-right: 1px solid ${Colors.primary};
    text-align: center;
    line-height: 70px;
`
const Text = styled.div `
    width: calc(100% - 70px);
    color: ${Colors.primary};
    font-family: "PT Sans";
    font-size: 16px;
    padding: 0 15px;
    
`



// WEBPACK FOOTER //
// ./src/containers/Preparation/Preparation.container.js